import React, { Component, PropTypes } from 'react';
import Select from 'react-select';
import { ENTER } from 'constants/ascii';
import { GBP_PROPERTIES, LOCATION_DATA_SOURCES, GBP_STEPS } from 'constants/gbp';
import LoadingIndicator from 'components/LoadingIndicator';

class GbpCreate extends Component {
  static propTypes = {
    fetchCategories: PropTypes.func,
    onChange: PropTypes.func,
    title: PropTypes.string,
    description: PropTypes.string,
    country: PropTypes.string,
    postalCode: PropTypes.string,
    state: PropTypes.string,
    city: PropTypes.string,
    streetAddress: PropTypes.string,
    category: PropTypes.string,
    phone: PropTypes.string,
    source: PropTypes.string,
    selected: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.object,
    ]),
    setGoogleLocationInfo: PropTypes.func,
    invalidProps:PropTypes.object,
    isLoading: PropTypes.bool,
    previousStep: PropTypes.number,
    location: PropTypes.object,
    categories: PropTypes.array,
    setCategories: PropTypes.func
  };

  constructor() {
    super();
    this.state = {
      category: null,
    }
  }

  componentDidMount() {
    const { setCategories, categories, fetchCategories, source, fetchAccountInfo, setGoogleLocationInfo, selected, previousStep, location } = this.props;
    if (source === LOCATION_DATA_SOURCES.NEW_LOCATION || source === LOCATION_DATA_SOURCES.GBP_EXISTING_LOCATION) {
      // Fetch categories
      fetchCategories().then(categories => {
        setCategories(categories);
      });
      if (previousStep === GBP_STEPS.VERIFICATION_OPTIONS) {
        this.setState({ category: categories.find(element => element.value === location.get('primaryCategoryId')) });
      }
    } else {
      this.setState({
        category: {
          value: selected.get('location').get('primaryCategoryId'),
          label: selected.get('location').get('primaryCategoryName'),
        }
      });
    }
    // Fetch location info
    if (source === LOCATION_DATA_SOURCES.NEW_LOCATION) {
      if (previousStep != GBP_STEPS.VERIFICATION_OPTIONS) {
        fetchAccountInfo();
      }
    }
    else {
      setGoogleLocationInfo(selected)
    }
  }

  componentDidUpdate({ category: prevCategory }) {
    const { category, source, categories } = this.props;
    if (((source === LOCATION_DATA_SOURCES.NEW_LOCATION && category !== prevCategory) || 
    (source === LOCATION_DATA_SOURCES.GBP_EXISTING_LOCATION && !this.state.category)) && categories.length && category ) {
      this.setState({ category: categories.find(element => element.value=== category) })
    }
  }

  onChange = (e, property) => {
    const { onChange } = this.props;
    const value = property === GBP_PROPERTIES.CATEGORY ? e.value : e.target.value;
    onChange(value, property);
  };

  onKeyDown = (e) => {
    if (e && e.keyCode === ENTER) {
      e.preventDefault();
    }
  };

  /**
   * get class name based on validity
   * @param {String} property property
   * @param {String} validClass class name
   * @returns
   */
  getClassName = (property, validClass = 'mui-textfield common-input mb-20') => {
    return `two-inputs-row ${this.props.invalidProps.has(property) ?
        'mui-textfield common-input mb-20 input-with-error' :
        validClass}`;
  }

  /**
   * Render error message alongside the input fields
   * @param {String} property property key
   * @returns react Node
   */
  renderErrorMsg = property => {
    let message;
    if (property === GBP_PROPERTIES.PHONE_NUMBER && !!this.props.phone) {
      message = 'Invalid phone number. Please follow the format +1 234 567 8910';
    } else {
      message = 'This Field Cannot Be Empty';
    }
    return this.props.invalidProps.has(property) ? <span className={'error-msg'}>{message}</span> : null;
  }

  render() {
    const {
      title,
      description,
      phone,
      source,
      postalCode,
      state,
      city,
      streetAddress,
      isLoading,
      categories
    } = this.props;
    const { category } = this.state;

    const isExistingLocation = source !== LOCATION_DATA_SOURCES.NEW_LOCATION;
    const isMyLocation = source === LOCATION_DATA_SOURCES.MY_LOCATION;

    return (
      <div>
        {isLoading ? <div className={'loadmore'}><LoadingIndicator loading={isLoading} /></div> :
          <div>
            <div className={'flex flex-col'}>
              <div className={'flex w-full flex-wrap-wrap'}>
                <div className={this.getClassName(GBP_PROPERTIES.CATEGORY)}>
                  <label>Category *</label>
                  <Select
                    options={categories}
                    isSearchable={true}
                    classNamePrefix={'ss-dropdown'}
                    onChange={(e) => {
                      this.onChange(e, GBP_PROPERTIES.CATEGORY);
                    }}
                    value={category}
                    isDisabled={isMyLocation || isLoading}
                  />
                  {this.renderErrorMsg(GBP_PROPERTIES.CATEGORY)}
                </div>
                <div className={this.getClassName(GBP_PROPERTIES.PROFILE_DESCRIPTION)}>
                  <label>Profile Description *</label>
                  <input
                    type='text'
                    value={description || ''}
                    onChange={(e) => {
                      this.onChange(e, GBP_PROPERTIES.PROFILE_DESCRIPTION);
                    }}
                    onKeyDown={this.onKeyDown}
                    disabled={isMyLocation}
                  />
                  {this.renderErrorMsg(GBP_PROPERTIES.PROFILE_DESCRIPTION)}
                </div>
                <div className={this.getClassName(GBP_PROPERTIES.BUSINESS_TITLE)}>
                  <label>Business Title *</label>
                  <input
                    type='text'
                    value={title || ''}
                    onChange={(e) => {
                      this.onChange(e, GBP_PROPERTIES.BUSINESS_TITLE);
                    }}
                    disabled={isExistingLocation}
                    onKeyDown={this.onKeyDown}
                  />
                  {this.renderErrorMsg(GBP_PROPERTIES.BUSINESS_TITLE)}
                </div>
                <div className={this.getClassName(GBP_PROPERTIES.PHONE_NUMBER)}>
                  <label>Phone Number *</label>
                  <input
                    type='text'
                    value={phone || ''}
                    onChange={(e) => {
                      this.onChange(e, GBP_PROPERTIES.PHONE_NUMBER);
                    }}
                    onKeyDown={this.onKeyDown}
                  />
                  {this.renderErrorMsg(GBP_PROPERTIES.PHONE_NUMBER)}
                </div>
              </div>
              <div className={'flex w-full flex-wrap-wrap'}>
                <div className={'two-inputs-row mui-textfield common-input mb-20'}>
                  <label>Street Address</label>
                  <div>{streetAddress}</div>
                </div>
                <div className={'two-inputs-row mui-textfield common-input mb-20'}>
                  <label>City</label>
                  <div>
                    {city}
                  </div>
                </div>
                <div className={'two-inputs-row mui-textfield common-input mb-20'}>
                  <label>State</label>
                  <div>
                    {state}
                  </div>
                </div>
                <div className={'two-inputs-row mui-textfield common-input mb-20'}>
                  <label>Postal Code</label>
                  <div>
                    {postalCode}
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>);
  }
}

export default GbpCreate;
